import { motion } from 'framer-motion';
import { UserCheckIcon, LeafIcon, HeartHandshakeIcon, SparklesIcon, EyeIcon, MessageCircleIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
const BROW_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/a9f2422c-facf-49d1-8117-b64235cce673.jpg';
const WHATSAPP_URL = 'https://wa.me/16159848577?text=Hola%20Karina%20%F0%9F%91%8B%20Vi%20tus%20servicios%20de%20dise%C3%B1o%20de%20cejas%20en%20Alexa%20Beauty%20y%20me%20gustar%C3%ADa%20agendar%20una%20cita.%20%C2%BFQu%C3%A9%20disponibilidad%20tienes%3F';
const GOLD = '#C9A96E';
const benefits = [{
  icon: UserCheckIcon,
  text: 'Diseño personalizado según tus facciones.'
}, {
  icon: LeafIcon,
  text: 'Resultado natural, limpio y definido.'
}, {
  icon: HeartHandshakeIcon,
  text: 'Atención directamente con Karina.'
}, {
  icon: SparklesIcon,
  text: 'Experiencia profesional y personalizada.'
}, {
  icon: EyeIcon,
  text: 'Ideal para quienes desean realzar su mirada sin exagerar.'
}, {
  icon: MessageCircleIcon,
  text: 'Citas disponibles mediante WhatsApp.'
}];
export function BrowServices() {
  return <section className="relative overflow-hidden px-5 sm:px-6 py-12 sm:py-16 lg:py-24" style={{
    background: 'linear-gradient(180deg, #ffffff 0%, #fdfbf7 55%, #ffffff 100%)'
  }} aria-labelledby="brow-services-title" data-id="element-87" data-mp="12jzbcig23uy4">
      {/* Brand watermark */}
      <img src={LOGO_URL} alt="" aria-hidden="true" loading="lazy" decoding="async" className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[150%] max-w-[420px] sm:max-w-[640px] lg:max-w-[900px] mix-blend-multiply opacity-[0.05] z-0" data-id="element-88" data-mp="euet61rq91pw" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-89" data-mp="1z9q6mjw69m4z">
        <div className="flex flex-col gap-8 lg:grid lg:grid-cols-[45fr_55fr] lg:gap-x-16 xl:gap-x-20 lg:gap-y-10 lg:items-start" data-id="element-90" data-mp="1z85cgvdrs57n">
          {/* Header — first on mobile, right column on desktop */}
          <motion.header initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:col-start-2 lg:row-start-1" data-id="element-91" data-mp="3raq6d6ce9fv0">
            <p className="text-[11px] sm:text-xs font-sans font-medium uppercase tracking-[0.25em] sm:tracking-[0.3em] mb-4 sm:mb-5" style={{
            color: GOLD
          }} data-id="element-92" data-mp="3cllq3up5tlpj">
              Brow Services by Karina
            </p>

            <h2 id="brow-services-title" className="font-serif text-luxury-black mb-4 sm:mb-5" style={{
            fontSize: 'clamp(2rem, 5.5vw, 3.25rem)',
            lineHeight: 1.1
          }} data-id="element-93" data-mp="3mdzs8ok5guc8">
              Tu mirada comienza con unas cejas que hablan de ti.
            </h2>

            <p className="font-sans font-light text-gray-600 max-w-[42ch]" style={{
            fontSize: 'clamp(1.0625rem, 1.6vw, 1.1875rem)',
            lineHeight: 1.6
          }} data-id="element-94" data-mp="14dp6zcfgxces">
              Un diseño pensado para realzar tus facciones, equilibrar tu mirada
              y ayudarte a sentirte aún más segura de ti.
            </p>
          </motion.header>

          {/* Editorial photograph — after the header on mobile, left column on desktop */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="order-2 lg:col-start-1 lg:row-start-1 lg:row-span-2 lg:sticky lg:top-24" data-id="element-95" data-mp="1s31gkdepjmhm">
            <img src={BROW_IMAGE} alt="Karina realizando un diseño profesional de cejas en Alexa Beauty." loading="lazy" decoding="async" sizes="(min-width: 1024px) 45vw, 100vw" className="w-full aspect-[4/5] object-cover object-center rounded-md" data-id="element-96" data-mp="2ntj4ml6701c" />
          </motion.div>

          {/* Body, benefits and CTA */}
          <div className="order-3 lg:col-start-2 lg:row-start-2" data-id="element-97" data-mp="d8kxoi5fhm0f">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="space-y-5 font-sans font-light text-gray-600 leading-relaxed" style={{
            fontSize: 'clamp(0.9375rem, 1.4vw, 1rem)'
          }} data-id="element-98" data-mp="97iyg1bih9yg">
              <p data-id="element-99" data-mp="rxhdj1dq83bl">
                Cada rostro es diferente y tus cejas también deberían serlo.
                Karina trabaja cada diseño de manera personalizada, observando
                la forma natural de tus cejas, tus facciones y el equilibrio de
                tu rostro para crear un resultado limpio, elegante y
                favorecedor.
              </p>
              <p data-id="element-100" data-mp="1s3b4x4gtj1rj">
                No se trata solamente de definir unas cejas. Se trata de
                encontrar la forma que mejor complementa tu expresión, resalta
                tu mirada y mantiene un acabado natural que realmente se sienta
                como tú.
              </p>
              <p className="text-luxury-black" data-id="element-101" data-mp="25y3teseorsa9">
                Cada cita está pensada para ofrecer una experiencia
                personalizada, cuidada y profesional de principio a fin.
              </p>
            </motion.div>

            {/* Benefits */}
            <ul className="mt-8 sm:mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5" data-id="element-102" data-mp="2kv4jysl55h75">
              {benefits.map(({
              icon: Icon,
              text
            }, index) => <motion.li key={text} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index % 2 * 0.08
            }} className="flex items-start gap-3 min-h-[44px]" data-id="element-103" data-mp="2otbxzfo804en" data-mpi={index}>
                  <Icon className="w-[18px] h-[18px] shrink-0 mt-0.5" style={{
                color: GOLD
              }} aria-hidden="true" data-id="element-104" data-mp="1sv16pm57sele" />
                  <span className="text-[15px] sm:text-base font-sans font-light text-luxury-dark leading-relaxed" data-id="element-105" data-mp="22qunjhpyuu8z">
                    {text}
                  </span>
                </motion.li>)}
            </ul>

            {/* Emotional line */}
            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="mt-10 sm:mt-12" data-id="element-106" data-mp="2qhqeydqifnfp">
              <p className="font-serif italic text-luxury-black leading-snug" style={{
              fontSize: 'clamp(1.25rem, 2.6vw, 1.75rem)'
            }} data-id="element-107" data-mp="2zi6fbebyiegc">
                "Pequeños detalles pueden transformar por completo una mirada."
              </p>
              <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7,
              delay: 0.2
            }} className="mt-6 h-[1px] w-20 origin-left" style={{
              backgroundColor: GOLD
            }} data-id="element-108" data-mp="3j2doj8s1vavs" />
            </motion.div>

            {/* CTA */}
            <div className="mt-8 sm:mt-10" data-id="element-109" data-mp="30542rkz95lbd">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex sm:inline-flex items-center justify-center gap-2.5 w-full sm:w-auto min-h-[56px] bg-luxury-black active:bg-luxury-dark sm:hover:bg-luxury-dark text-white font-sans font-medium text-xs sm:text-sm tracking-[0.2em] uppercase px-10 py-4 rounded-sm transition-colors duration-300 border border-transparent" style={{
              boxShadow: `inset 0 -2px 0 0 ${GOLD}`
            }} data-id="element-110" data-mp="306xc58192jn2">
                <MessageCircleIcon className="w-[18px] h-[18px]" style={{
                color: GOLD
              }} aria-hidden="true" data-id="element-111" data-mp="2rwrnnv6alufu" />
                Agendar mi cita
              </a>

              <p className="mt-4 text-[15px] text-gray-600 font-sans text-center sm:text-left" data-id="element-112" data-mp="2ivtfd0otn0rg">
                Citas y atención directamente con Karina por WhatsApp.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}